/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const chatCountModelSchema = z.object({
    "count": z.number().int().describe("Число незакрытых обращений")
    })